export { default as i18n } from "./i18n";
export { default } from "./BookingsSearchContainer";
export { default as reducer } from "./reducer";

import { BookingSearchViewState as TBookingSearchViewState } from "./types";
export type BookingSearchViewState = TBookingSearchViewState;
